module.exports = __webpack_public_path__ + "4fb5dc64ecf86a6baba328c799a4a884.fbx";